<script setup lang="ts">
definePageMeta({
  layout: false,
  middleware: "auth",
});

useHead({
  title: "IEW Writing Companion",
  link: [{ rel: "icon", type: "image/png", href: "/img/favicon-companion.png", key: "favicon" }],
});
</script>

<template>
  <div class="h-screen w-screen">
    <CompanionLayout />
  </div>
</template>
